module.exports = {"widget-system":232,"player-debug-info":233,"widget.vid.share.clicked":225}


//////////////////
// WEBPACK FOOTER
// ./src/shared/bi/events.json
// module id = 1137
// module chunks = 15 16 17 18 19